import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('snackbar', ['showSnack']),
    ...mapActions('loading', ['showLoading']),
  },
}
